export function redirectToLoginPage(){
   window.location.href='/app/login';
}
export function redirectToDashboard(){
   window.location.href='/app/dashboard';
}